export const environment = {
  production: false,
  debug: true, // Enable debug for staging
  isGenericFlow: true, // Always true
  // Staging backend API URL (Digital Ocean droplet)
  frontendUrl: 'https://stage.aioptima.io',
  apiUrl: 'https://stage-api.aioptima.io',
  useWebSocket: true,
  overviewFastMode: true
//   apiUrl: 'https://api.aioptima.io'
};
